import supabase from "artifact/supabase";
import * as f from "standard/f";
import trait from "standard/trait";
import InFuture from "./inFuture";
import status from "./status";
import style from "./style";

class ToReview {
  #data;

  get deck() {
    return this.#data.deck.id;
  }

  get user() {
    return this.#data.user_id;
  }

  constructor(data) {
    this.#data = data;
  }

  template() {
    return `
      <a class='${style.study}' href='/${this.user}/deck/${this.deck}/card' ${status.TO_REVIEW}>
        Estudar
      </a>
    `;
  }

  static async create(study) {
    const { data } = await supabase
      .from("card")
      .select("user_id, deck(*)")
      .eq("deck", study[trait.deck])
      .lte("validity", study[trait.validity])
      .limit(1)
      .single();

    return f.isNil(data) ? await InFuture.create(study) : new ToReview(data);
  }
}

export default ToReview;
